import VuexPersistence from 'vuex-persist';
import { createStore } from 'vuex';

import users from './modules/users';
import account from './modules/account';
import meta from './modules/meta';
import clients_users from './modules/clients_users';
import clients_account from './modules/clients_account';
import admins_users from './modules/admins_users';
import admins_dashboard from './modules/admins_dashboard';
import admins_tenants from './modules/admins_tenants';

const vuexLocal = new VuexPersistence({
    key: 'abire_planeta_vivo',
    modules: ['users'],
    storage: window.localStorage,
});

const vuexClientLocal = new VuexPersistence({
    key: 'abire_planeta_vivo_client',
    modules: ['clients_users'],
    storage: window.localStorage,
});

const vuexAdminLocal = new VuexPersistence({
    key: 'abire_planeta_vivo_admin',
    modules: ['admins_users'],
    storage: window.localStorage,
});

export default createStore({
    modules: {
        users,
        account,
        meta,
        clients_users,
        clients_account,
        admins_users,
        admins_dashboard,
        admins_tenants,
    },
    plugins: [vuexLocal.plugin, vuexClientLocal.plugin, vuexAdminLocal.plugin],
});
